const EnumPlugin = {
    install(Vue, enums) {
        for (var enumName in enums) { this[enumName] = enums[enumName]; }
        Vue.prototype.$enum = EnumPlugin;
    }
};

export default EnumPlugin;